import React, {cloneElement} from 'react';
import {Route, Switch, useRouteMatch} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    tiny: {
        position: 'absolute',
        left: 0,
        bottom: 0,
        fontSize: 7.5,
        backgroundColor: '#ffffff',
        zIndex: 99999,
    },
}));

const PopupRouter = props => {
    const classes = useStyles();
    let {url} = useRouteMatch();

    return (
        <div>
            {window.location.host.indexOf('ashlar') > -1 && <span className={classes.tiny}>{window.location.pathname}</span>}
            <Switch>
                <Route path={`${url}/contact/:editId`}>
                    {cloneElement(props.parent.routes.editContact.component, {
                        ...props,
                        editType: 'contact',
                        parentRefresh: () => {
                        },
                        parent: props.parent.routes.editContact
                    })}
                </Route>
                <Route path={`${url}/account/:editId`}>
                    {cloneElement(props.parent.routes.editAccount.component, {
                        ...props,
                        editType: 'account',
                        parentRefresh: () => {
                        },
                        parent: props.parent.routes.editAccount
                    })}
                </Route>
                <Route path={`${url}/analyze-keywords`}>
                    {cloneElement(props.parent.routes.analyzeKeywords.component, {
                        ...props,
                    })}
                </Route>
                <Route path={`${url}/user-preferences`}>
                    {cloneElement(props.parent.routes.userPreferences.component, {
                        ...props,
                    })}
                </Route>
                <Route path={`${url}/sign-in`}>
                    {cloneElement(props.parent.routes.signIn.component, {
                        ...props,
                    })}
                </Route>
            </Switch>
        </div>
    );
};

export default PopupRouter;
